import axios from 'axios'
import dateTimeFormater from '../dateTimeFormater'

const sendWebcastDataCreate = (data, host = '') => {

  const postData = {
    channel: { id: data.channel.id },
    title: typeof data.title === 'undefined' ? undefined : data.title.trim(),
    scheduled: dateTimeFormater(data.startDate, data.startTime, data.timeZone),
    provider: data.provider,
    serviced: data.serviced ? 'true' : 'false',
    showChannelSurvey: data.showChannelSurvey || false,
    clientBookingReference: typeof data.clientBookingReference === 'undefined' ? undefined : data.clientBookingReference.trim(),
    duration: (data.provider && data.provider.name === 'replay') ? data.duration : data.duration * 60,
    description: typeof data.description === 'undefined' ? undefined : data.description.trim(),
    keywords: data.keywords,
    presenter: typeof data.presenter === 'undefined' ? undefined : data.presenter.trim(),
    timeZone: data.timeZone,
    visibility: data.visibility,
    format: 'video',
    publishStatus: 'published',
    categories: data.categorisationTags,
    allowAnonymous: typeof data.allowAnonymous === 'undefined' ? undefined : data.allowAnonymous,
    autoTranscriptions:  data.autoCaptions === 'true' ? { enabled: 'true', language: data.autoCaptionsLanguage || 'en-US' }
    : { enabled: 'false' }
  }

  if (data.links) {
    // @ts-ignore
    postData.links = data.links
  }

  return axios.post(`${host}/service/communication/v1/channel/${data.channel.id}/communication`, postData ,
    {
      headers: {
        'content-type': 'application/json',
        'accept': 'application/json'
      }
    }
  )

}

export default sendWebcastDataCreate
